import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { createDecorator, Form, FormProps, PecFormApi } from 'components/form'
import { useFlags } from 'config/useFlagsContext'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { useMemo } from 'react'
import { MetaRoot } from 'util/metaPath'

import { CuidadoCompartilhadoPlanoModel } from '../model-cuidadocompartilhado'
import { cuidadoCompartilhadoFormCalculator } from './calculator-cuidadoCompartilhado'
import { cuidadoCompartilhadoFormValidator } from './validator-cuidadoCompartilhado'

interface CuidadoCompartilhadoFormProps
  extends Omit<FormProps<CuidadoCompartilhadoPlanoModel>, 'validate' | 'decorators'> {
  isAtendimentoOdonto: boolean
  path: MetaRoot<CuidadoCompartilhadoPlanoModel>
  encaminhamentos: readonly CuidadoCompartilhadoPlanoModel[]
  isEdit?: boolean
}

export const CuidadoCompartilhadoForm = (props: CuidadoCompartilhadoFormProps) => {
  const { path, encaminhamentos, isAtendimentoOdonto, isEdit = false, onSubmit, ...rest } = props

  const {
    permissoes: { somenteCiap },
  } = useAtendimentoContext()
  const { acesso } = useAcessoLotacaoOrEstagio()
  const flags = useFlags()

  const handleSubmit = (
    values: CuidadoCompartilhadoPlanoModel,
    formApi: PecFormApi<CuidadoCompartilhadoPlanoModel>
  ) => {
    onSubmit(values, formApi)
    setTimeout(formApi.reset)
  }

  const decorator = useMemo(
    () => createDecorator(...cuidadoCompartilhadoFormCalculator(path, somenteCiap, isEdit, isAtendimentoOdonto, flags)),
    [flags, isAtendimentoOdonto, isEdit, path, somenteCiap]
  )

  return (
    <Form<CuidadoCompartilhadoPlanoModel>
      validate={cuidadoCompartilhadoFormValidator(
        acesso.unidadeSaude.id,
        acesso.cbo.cbo2002,
        flags,
        encaminhamentos,
        isAtendimentoOdonto
      )}
      decorators={[decorator]}
      onSubmit={handleSubmit}
      {...rest}
    />
  )
}
